import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { TimeManagementIllustration } from './TimeManagement';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const TimeManagement = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <TimeManagementIllustration title={title} />
  </IllustrationWrapper>
);
